/**
* Created by Omar Alejandro Leonor Avalos on 2017-06-06.
* Item model for each "despacho"
*/
import React, { Component } from 'react';
import FlatButton from 'material-ui/FlatButton';
import Block from 'material-ui/svg-icons/content/block';
import Guardar from 'material-ui/svg-icons/content/save';
import Trash from 'material-ui/svg-icons/action/delete';
import Edit from 'material-ui/svg-icons/content/create';
import Tabulador from 'material-ui/svg-icons/image/grid-on';
import IconButton from 'material-ui/IconButton';
import { EditableInlineV2 } from '../../../components/text';
import { COUNTRY_LIST } from '../../../data/selects';
import { setValueIn } from '../../../common/immutable';
import { parsePath, getValueFromSelectList } from '../../../common/helpers';
import { buildErrorsState, validateField, errorsEmpty } from '../../../validations';
import { Alert } from '../../../components/data-containers';

//Fields goes here, it might corresponds with the names of the props
//you modify on state
const errorsProps = {
    name: [],
    executiveUser: [],
    taxId: [],
    phone1: [],
    email1: [],
    street: [],
    externalNumber: [],
    internalNumber: [],
    zipCode: []
};

//Each rule might correspond with the key for the field to validate
//For now I only use comertialInvoiceNumber
const rules = {
    name: [{ key: 'required', errorText: 'Campo requerido' }],
    taxId: [{ key: 'required', errorText: 'Campo requerido' }],
    phone1: [
        { key: 'required', errorText: 'Campo requerido' },
        { key: 'onlyNumbers', errorText: 'Solo Números' },
        { key: 'validationPhone1', errorText: 'Numero telefonico tiene que ser de 10 digitos' }
    ],
    email1: [
        { key: 'required', errorText: 'Campo requerido' },
        { key: 'validationEmail', errorText: 'Ingrese un correo valido' }
    ],
    street: [{ key: 'required', errorText: 'Campo requerido' }],
    externalNumber: [
        { key: 'required', errorText: 'Campo requerido' }
    ],
    internalNumber: [
        { key: 'required', errorText: 'Campo requerido' }
    ],
    zipCode: [
        { key: 'required', errorText: 'Campo Requerido' },
        { key: 'validationZipCode', errorText: 'Codigo postal tiene que ser meno o igual a 10 digitos' }
    ]

};

class Item extends Component {

    constructor(props) {
        super(props);
        this.state = {
            editing: false,
            customer: props.customer,
            errors: { ...errorsProps },
            openAlert: false
        };
    }

    updateCustomer(path, value, path2) {
        //Recalculate errors
        const errors = Object.assign(
            {},
            this.state.errors,
            validateField(rules, path2, value)
        );
        const customer = setValueIn(parsePath(path), value, this.state.customer);
        this.setState({ customer, errors });
    }

    renderButtons(editing, customer, onSave) {
        const { allowUpdate, allowDelete } = this.props;
        return (
            <div className="space-around">
                {
                    editing && <IconButton
                        tooltip="Cancelar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => this.setState({ editing: false, customer, errors: errorsProps })}
                    >
                        <Block />
                    </IconButton>
                }
                {editing && <div className="vertical-line" />}
                {
                    editing && <IconButton
                        tooltip="Guardar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => {
                            if (errorsEmpty(this.state.errors)) {
                                this.setState({ editing: false });
                                onSave(this.state.customer);
                            }
                        }}
                    >
                        <Guardar />
                    </IconButton>
                }
                {editing && <div className="vertical-line" />}
                {
                    (!editing && allowUpdate) && <IconButton
                        tooltip="Editar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => {
                            if (!allowUpdate) { return; }
                            this.setState({ customer: customer })
                            this.setState({ editing: true });
                        }}
                    >
                        <Edit />
                    </IconButton>
                }
                {editing && <div className="vertical-line" />}
                {
                    (!editing && allowDelete) && <IconButton
                        tooltip="Eliminar deschacho"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => {
                            if (!allowDelete) { return; }
                            this.setState({ openAlert: true });
                        }}
                    >
                        <Trash />
                    </IconButton>
                }
            </div>
        );
    }

    render() {
        const { editing, errors } = this.state;
        const { customer, executiveUsersList = [], onOpenInfoModal, onSave, actions, allowCreateTabular, allowReadTabular } = this.props;
        const currentProperties = editing ? this.state.customer : customer;
        const { name, taxId, phone1, phone2, email1, email2, email3, address, street, externalNumber, executiveUser, edited } = currentProperties;

        return (
            <div style={{ marginBottom: 2 }} className="margin-bottom-2">
                <div className="col-md-12 main-card item-row">
                    <div className="row">
                        <div
                            className="col-lg-10 col-md-9 col-sm-6 col-xs-12 tabulador hidden-md-down"
                            style={{ minHeight: '3.6rem' }}
                            onClick={() => allowCreateTabular && onOpenInfoModal()}
                        >
                            {
                                (allowCreateTabular || allowReadTabular) &&
                                <FlatButton
                                    label="Tabulador"
                                    labelPosition="after"
                                    primary
                                    onClick={onOpenInfoModal}
                                    icon={<Tabulador />}
                                />
                            }
                        </div>
                        <div
                            className="col-lg-2 col-md-3 col-sm-6 col-xs-12 card-buttons hidden-md-down"
                            style={{ minHeight: '3.6rem', paddingTop: '0.8rem' }}
                        >
                            {this.renderButtons(editing, customer, onSave)}
                        </div>
                    </div>
                    <div className="row white-card padding-2">
                        <div className="row">
                            <div className="col-md-2">
                                <div className="col-md-12">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        value={name}
                                        label="Nombre o Razón Social"
                                        fieldClass="nombre-cliente"
                                        notify={(value) => this.updateCustomer('name', value, 'name')}
                                        errorText={errors.name.join(' | ')}
                                    />
                                </div>
                            </div>
                            <div className="col-md-10">
                                <div className="col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        type="autocomplete"
                                        label="Ejecutivo de ventas"
                                        value={getValueFromSelectList(executiveUsersList, executiveUser).name}
                                        items={executiveUsersList}
                                        notify={(item) => {
                                            this.updateCustomer('executiveUser', item.id, 'executiveUser');
                                        }}
                                        errorText={errors.executiveUser.join(' | ')}
                                    />
                                </div>
                                <div className="col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        label="RFC"
                                        value={taxId}
                                        notify={(value) => this.updateCustomer('taxId', value, 'taxId')}
                                        errorText={errors.taxId.join(' | ')}
                                    />
                                </div>
                                <div
                                    className="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                    style={{ background: '#f9f9f9', padding: '1rem 0rem', margin: '1rem 0rem' }}
                                >
                                    <div className="col-lg-2 col-md-6 col-sm-6 col-xs-12">
                                        <EditableInlineV2
                                            editViewActive={editing}
                                            label="Teléfono 1"
                                            value={phone1}
                                            notify={(value) => this.updateCustomer('phone1', value, 'phone1')}
                                            errorText={errors.phone1.join(' | ')}
                                        />
                                    </div>
                                    <div className="col-lg-2 col-md-6 col-sm-6 col-xs-12">
                                        <EditableInlineV2
                                            editViewActive={editing}
                                            label="Teléfono 2"
                                            value={phone2}
                                            notify={(value) => this.updateCustomer('phone2', value, 'phone2')}
                                        />
                                    </div>
                                    <div className="col-lg-2 col-md-6 col-sm-6 col-xs-12">
                                        <EditableInlineV2
                                            editViewActive={editing}
                                            label="Correo Electrónico 1"
                                            value={email1}
                                            notify={(value) => this.updateCustomer('email1', value, 'email1')}
                                            errorText={errors.email1.join(' | ')}
                                        />
                                    </div>
                                    <div className="col-lg-2 col-md-6 col-sm-6 col-xs-12">
                                        <EditableInlineV2
                                            editViewActive={editing}
                                            label="Correo Electrónico 2"
                                            value={email2}
                                            notify={(value) => this.updateCustomer('email2', value, 'email2')}
                                        />
                                    </div>
                                    <div className="col-lg-2 col-md-6 col-sm-6 col-xs-12">
                                        <EditableInlineV2
                                            editViewActive={editing}
                                            label="Correo Electrónico 3"
                                            value={email3}
                                            notify={(value) => this.updateCustomer('email3', value, 'email3')}
                                        />
                                    </div>

                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        label="Calle"
                                        value={address.street}
                                        notify={(value) => {
                                            this.updateCustomer('address>street', value, 'street')
                                        }}
                                        errorText={errors.street.join(' | ')}
                                    />
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        label="Número Exterior"
                                        value={address.externalNumber}
                                        notify={(value) => this.updateCustomer('address>externalNumber', value, "externalNumber")}
                                        errorText={errors.externalNumber.join(' | ')}

                                    />
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        label="Número Interior"
                                        value={address.internalNumber}
                                        notify={(value) => this.updateCustomer('address>internalNumber', value, 'internalNumber')}
                                        errorText={errors.internalNumber.join(' | ')}

                                    />
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        label="Código Postal"
                                        value={address.zipCode}
                                        notify={(value) => this.updateCustomer('address>zipCode', value, 'zipCode')}
                                        errorText={errors.zipCode.join(' | ')}
                                    />
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        label="Colonia"
                                        value={address.colony}
                                        notify={(value) => this.updateCustomer('address>colony', value, 'colony')}
                                    />
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        label="Ciudad"
                                        value={address.city}
                                        notify={(value) => this.updateCustomer('address>city', value, 'city')}
                                    />
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        label="Municipio"
                                        value={address.municipality != null ? address.municipality : ""}
                                        notify={(value) => this.updateCustomer('address>municipality', value, 'municipality')}
                                    />
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        label="Estado"
                                        value={address.state}
                                        notify={(value) => this.updateCustomer('address>state', value, 'state')}
                                    />
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        type="autocomplete"
                                        label="País"
                                        value={address.country != null ? getValueFromSelectList(COUNTRY_LIST.items, address.country).name : ""}
                                        items={COUNTRY_LIST.items}
                                        notify={(item) => {
                                            this.updateCustomer('address>country', item.id, 'country');
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-2 col-sm-6 col-md-6 hidden-lg-up" />
                        <div
                            className="col-xs-4 col-sm-3 col-md-3 tabulador hidden-lg-up"
                            style={{ minHeight: '3.6rem' }}
                        >
                            {
                                allowCreateTabular &&
                                <FlatButton
                                    label="Tabulador"
                                    labelPosition="after"
                                    primary
                                    onClick={onOpenInfoModal}
                                    icon={<Tabulador />}
                                />
                            }
                        </div>
                        <div
                            className="col-xs-6 col-sm-3 col-md-3 card-buttons hidden-lg-up"
                            style={{ minHeight: '3.6rem', paddingTop: '0.8rem', marginBottom: '2rem' }}
                        >
                            {this.renderButtons(editing, customer, onSave)}
                        </div>
                    </div>
                    <Alert
                        open={this.state.openAlert}
                        close={() => this.setState({ openAlert: false })}
                        message={"Seguro que quieres eliminar este cliente?"}
                        delteEntry={() => {
                            this.setState({ openAlert: false });
                            actions.deleteCustomer(customer);
                        }}
                    />
                </div >
            </div >
        );
    }
}

export default Item;



// WEBPACK FOOTER //
// ./containers/clientes/components/item.js